import { ISurveyUserReview } from './../views/pages/survey/surveyAdd/type';
/* eslint-disable import/named */
import { JwtPayloadType } from 'types/authType';
import { getLocalStorage, setLocalStorage } from 'utils/browserStorageUtil';
import { CombineTypeAnswer, mappingSelectType } from 'views/pages/questionBank/questionAdd/types';
import {
  DdlDepartment,
  ICreateOneAndManyAnswer,
  ICreateQuestionNoAnswer,
  IListAnswerDrag,
  IListMatrixAnsColIndexFromQuestionMatrix,
  IListMatrixAnsColIndexFromQuestionMatrixList,
  IListMatrixAnsRowIndexFormQuestionMatrixList,
} from 'views/pages/questionBank/type';

import colors from 'assets/scss/_themes-vars.module.scss';
import dayjs from 'dayjs';
import range from 'lodash/range';
import uniqBy from 'lodash/uniqBy';
import React from 'react';
import { RATING_DEFAULT_COLOR, RATING_SELECTED_COLOR } from 'views/pages/questionBank/constant';
import { SurveyConst } from 'views/pages/survey/context/surveyContext';
import { IReorderQuestion } from 'views/pages/survey/surveyAdd/type';
import { ISectionGroup } from 'views/pages/survey/type';
import { IS_PRIORITY_CLICK_HIGHLIGHT } from 'views/pages/surveyList/previewSurveyDevice/types';
import {
  FetchFunctionProps,
  ItemsType,
} from 'components/molecules/CustomizedVirtualizedSelect/SelectLoadingWithApi/InfiniteLoadingSelect';
import { postDDLSearchStaffApi } from 'api/surveyApi';

type PrependNextNum<A extends Array<unknown>> = A['length'] extends infer T
  ? ((t: T, ...a: A) => void) extends (...x: infer X) => void
    ? X
    : never
  : never;
type EnumerateInternal<A extends Array<unknown>, N extends number> = {
  0: A;
  1: EnumerateInternal<PrependNextNum<A>, N>;
}[N extends A['length'] ? 0 : 1];
export type Enumerate<N extends number> = EnumerateInternal<[], N> extends (infer E)[] ? E : never;
export type Range<FROM extends number, TO extends number> = Exclude<Enumerate<TO>, Enumerate<FROM>>;

export const decodeJwt = (token: string): JwtPayloadType => {
  if (!token) return null;
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
};

export function moveItemInArray<T>(workArray: T[], fromIndex: number, toIndex: number): T[] {
  if (toIndex === fromIndex) {
    return workArray;
  }
  const target = workArray[fromIndex];
  const increment = toIndex < fromIndex ? -1 : 1;

  for (let k = fromIndex; k !== toIndex; k += increment) {
    workArray[k] = workArray[k + increment];
  }
  workArray[toIndex] = target;
  return workArray;
}

export const reverseMappingSelectType = Object.keys(mappingSelectType).reduce((prev, curr) => {
  const key = mappingSelectType[curr];
  Object.assign(prev, { [key]: curr });
  return prev;
}, {} as { [x: string]: string });

const randomNumber = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1) + min);
const randomByte = () => randomNumber(0, 255);
const randomPercent = () => (randomNumber(50, 100) * 0.01).toFixed(2);
export const randomCssRgba = () =>
  `rgba(${[randomByte(), randomByte(), randomByte(), randomPercent()].join(',')})`;

export const handleGetUSerID = () => {
  const infoUser = getLocalStorage('infoUser');
  if (!infoUser) {
    return '';
  }
  const userInfoParse = JSON.parse(infoUser) || '';
  if (!userInfoParse) return '';
  if (userInfoParse?.userID) return userInfoParse?.userID;
  return '';
};

//get email user
export const handleGetUserInfo = () => {
  const profile = localStorage.getItem('SSOInformations');
  if (profile) {
    const profileEmail = JSON.parse(profile).profile.email ?? '';
    const profilePhone = JSON.parse(profile).profile.phone ?? '';
    return {
      email: profileEmail,
      phone: profilePhone,
    };
  }
  return null;
};

interface IGenerateInitialValues {
  questionGroupID?: string | null;
  departments?: DdlDepartment[] | null;
  selectType?: string;
  listMatrixRow?: IListMatrixAnsRowIndexFormQuestionMatrixList[];
  listMatrixColumn?:
    | IListMatrixAnsColIndexFromQuestionMatrix[]
    | IListMatrixAnsColIndexFromQuestionMatrixList[];
  questionContent?: string;
  answers?: IListAnswerDrag[];
}

/**
 * Type 1: For MANY, ONE Question
 */
const initialValueOneAndMany = {
  questionID: '',
  questionGroupID: '',
  departments: [],
  isOther: false,
  isRequired: false,
  questionTypeID: '1',
  questionContent: '',
  isDropDown: false,
  isHaveOther: false,
  questionImage: '',
  isQuestionBank: true,
  categoryID: 0,
  nextQuestion: '1',
  availableQuestionID: '',
  isHaveImage: false,
  creator: '',
  userCanUpdateQuestion: [] as string[],
  answers: [
    {
      answerContent: '',
      answerID: '',
      imagePath: '',
      isDeleteImage: false,
      isHaveImage: false,
      isOther: false,
      nextQuestion: '',
      numericalOrder: 0,
      objFile: null,
    },
    {
      answerContent: '',
      answerID: '',
      imagePath: '',
      isDeleteImage: false,
      isHaveImage: false,
      isOther: false,
      nextQuestion: '',
      numericalOrder: 1,
      objFile: null,
    },
    {
      answerContent: '',
      answerID: '',
      imagePath: '',
      isDeleteImage: false,
      isHaveImage: false,
      isOther: false,
      nextQuestion: '',
      numericalOrder: 2,
      objFile: null,
    },
    {
      answerContent: '',
      answerID: '',
      imagePath: '',
      isDeleteImage: false,
      isHaveImage: false,
      isOther: false,
      nextQuestion: '',
      numericalOrder: 3,
      objFile: null,
    },
  ],
};

export const defaultAnswerList = [
  {
    answerContent: '',
    answerID: '',
    imagePath: '',
    isDeleteImage: false,
    isHaveImage: false,
    isOther: false,
    nextQuestion: '',
    numericalOrder: 0,
    objFile: null,
  },
  {
    answerContent: '',
    answerID: '',
    imagePath: '',
    isDeleteImage: false,
    isHaveImage: false,
    isOther: false,
    nextQuestion: '',
    numericalOrder: 1,
    objFile: null,
  },
  {
    answerContent: '',
    answerID: '',
    imagePath: '',
    isDeleteImage: false,
    isHaveImage: false,
    isOther: false,
    nextQuestion: '',
    numericalOrder: 2,
    objFile: null,
  },
  {
    answerContent: '',
    answerID: '',
    imagePath: '',
    isDeleteImage: false,
    isHaveImage: false,
    isOther: false,
    nextQuestion: '',
    numericalOrder: 3,
    objFile: null,
  },
];

export const defaultAnswer = {
  answerID: '',
  answerContent: '',
  numericalOrder: 0,
  nextQuestion: '',
  isOther: false,
  imagePath: '',
  isDeleteImage: false,
  isHaveImage: false,
  objFile: null,
};

/**
 * Type 2: For TEXT, DATE, NUMBER, TIME
 */
const initialValuesNoAnswer = {
  questionID: '',
  questionGroupID: '',
  departments: [],
  isRequired: false,
  questionTypeID: '1',
  questionContent: '',
  isDropDown: false,
  isHaveOther: false,
  questionImage: '',
  isQuestionBank: true,
  nextQuestion: '1',
  creator: '',
  userCanUpdateQuestion: [] as string[],
};
/**
 * Type 3: For RATING (A.K.A LINE UP)
 */
const initialValuesRating = {
  questionID: '',
  questionTypeID: '1',
  questionGroupID: '',
  departments: [],
  questionContent: '',
  isRequired: false,
  iconType: 5,
  maxLevel: 6,
  isQuestionBank: true,
  nextQuestion: '1',
  creator: '',
  userCanUpdateQuestion: [] as string[],
};
/**
 * Type 4: For MATRIX
 */

// Matrix
export const listMatrixRowDefault = [
  {
    answerRowID: '',
    questionID: '',
    answerRowContent: '',
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
    numericalOrder: 0,
  },
  {
    answerRowID: '',
    questionID: '',
    answerRowContent: '',
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
    numericalOrder: 1,
  },
  {
    answerRowID: '',
    questionID: '',
    answerRowContent: '',
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
    numericalOrder: 2,
  },
];
export const listMatrixColumnDefault = [
  {
    answerColumnID: '',
    answerRowID: '',
    answerColumnContent: '',
    isDropDown: false,
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
    numericalOrder: 0,
  },
  {
    answerColumnID: '',
    answerRowID: '',
    answerColumnContent: '',
    isDropDown: false,
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
    numericalOrder: 1,
  },
  {
    answerColumnID: '',
    answerRowID: '',
    answerColumnContent: '',
    isDropDown: false,
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
    numericalOrder: 2,
  },
];
// Matrix Form List
export const listMatrixRowDefaultForList = [
  {
    answerRowID: '',
    questionID: '',
    answerRowContent: '',
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
  },
  {
    answerRowID: '',
    questionID: '',
    answerRowContent: '',
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
  },
  {
    answerRowID: '',
    questionID: '',
    answerRowContent: '',
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
  },
];
export const listMatrixColumnDefaultForList = [
  {
    answerColumnID: '',
    answerRowID: '',
    answerColumnContent: '',
    isDropDown: false,
    listMatrixCategories: [
      {
        matrixCategoryID: '',
        answerColumnID: '',
        matrixCategoryName: '',
      },
    ],
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
    numericalOrder: 0,
  },
  {
    answerColumnID: '',
    answerRowID: '',
    answerColumnContent: '',
    isDropDown: false,
    listMatrixCategories: [
      {
        matrixCategoryID: '',
        answerColumnID: '',
        matrixCategoryName: '',
      },
    ],
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
    numericalOrder: 1,
  },
  {
    answerColumnID: '',
    answerRowID: '',
    answerColumnContent: '',
    isDropDown: false,
    listMatrixCategories: [
      {
        matrixCategoryID: '',
        answerColumnID: '',
        matrixCategoryName: '',
      },
    ],
    imagePath: '',
    objFile: null,
    isDeleteImage: false,
    isOther: false,
    numericalOrder: 2,
  },
];
const initialValuesMatrixAndMatrixList = {
  questionID: '',
  questionTypeID: '1',
  questionGroupID: '',
  departments: [],
  questionContent: '',
  isRequired: false,
  isMultipleSelect: false,
  listMatrixAnsRowIndex: listMatrixRowDefault,
  listMatrixAnsColIndex: listMatrixColumnDefault,
  questionImage: '',
  isQuestionBank: true,
  nextQuestion: '1',
  creator: '',
  userCanUpdateQuestion: [] as string[],
};

export const defaultFormValue = {
  questionContent: '',
  answers: defaultAnswerList,
  categoryID: 0,
  listMatrixAnsRowIndex: listMatrixRowDefault,
  listMatrixAnsColIndex: listMatrixColumnDefault,
  listMatrixListAnsRowIndex: listMatrixRowDefaultForList,
  listMatrixListAnsColIndex: listMatrixColumnDefaultForList,
  imagePath: '',
  isHaveOther: false,
};

const initialValuesBranch = {
  questionID: '',
  questionGroupID: '',
  departments: [],
  isOther: false,
  isRequired: false,
  questionTypeID: '1',
  questionContent: '',
  isDropDown: false,
  isHaveOther: false,
  questionImage: '',
  isQuestionBank: true,
  categoryID: 0,
  nextQuestion: '1',
  availableQuestionID: '',
  isHaveImage: false,
  creator: '',
  userCanUpdateQuestion: [] as string[],
  answers: [
    {
      answerContent: '',
      answerID: '',
      imagePath: '',
      isDeleteImage: false,
      isHaveImage: false,
      isOther: false,
      nextQuestion: '1',
      numericalOrder: 0,
      objFile: null,
    },
    {
      answerContent: '',
      answerID: '',
      imagePath: '',
      isDeleteImage: false,
      isHaveImage: false,
      isOther: false,
      nextQuestion: '1',
      numericalOrder: 1,
      objFile: null,
    },
    {
      answerContent: '',
      answerID: '',
      imagePath: '',
      isDeleteImage: false,
      isHaveImage: false,
      isOther: false,
      nextQuestion: '1',
      numericalOrder: 2,
      objFile: null,
    },
    {
      answerContent: '',
      answerID: '',
      imagePath: '',
      isDeleteImage: false,
      isHaveImage: false,
      isOther: false,
      nextQuestion: '1',
      numericalOrder: 3,
      objFile: null,
    },
  ],
};

const initialValueEvaluatedQuestion = {
  questionID: '',
  questionTypeID: '10',
  questionGroupID: 'GGENE',
  departments: [],
  questionContent: 'Người được đánh giá',
  isRequired: true,
  isDropDown: true,
  isHaveOther: false,
  isQuestionBank: false,
  isDeleteImage: false,
  nextQuestion: '1',
  categoryID: 0,
  answers: [],
  surveyID: '',
  availableQuestionID: '',
  creator: '',
  userCanUpdateQuestion: [] as string[],
};

export const generateInitialValues = ({
  questionGroupID = '',
  departments = [],
  selectType = '1',
  listMatrixRow = [],
  listMatrixColumn = [],
  questionContent = '',
}: IGenerateInitialValues) => {
  const oneAndManyQuestion = [mappingSelectType.oneAnswer, mappingSelectType.manyAnswer] as const;
  const noAnswerQuestion = [
    mappingSelectType.text,
    mappingSelectType.number,
    mappingSelectType.chooseDate,
    mappingSelectType.choseHour,
  ] as const;
  const ratingQuestion = [mappingSelectType.lineUp] as const;
  const matrixAndMatrixListQuestion = [
    mappingSelectType.matrix,
    mappingSelectType.matrixFromList,
  ] as const;
  const branchQuestion = [mappingSelectType.oneAnswer360branch] as const;
  const evaluatedQuestion = [mappingSelectType.evaluated] as const;
  const questionTypeID = mappingSelectType[selectType];

  if (oneAndManyQuestion.includes(questionTypeID)) {
    return {
      ...initialValueOneAndMany,
      questionGroupID,
      departments,
      questionTypeID,
      questionContent,
    } as unknown as ICreateOneAndManyAnswer;
  }
  if (noAnswerQuestion.includes(questionTypeID)) {
    return {
      ...initialValuesNoAnswer,
      questionGroupID,
      departments,
      questionTypeID,
      questionContent,
    } as unknown as ICreateQuestionNoAnswer;
  }
  if (ratingQuestion.includes(questionTypeID)) {
    return {
      ...initialValuesRating,
      questionGroupID,
      departments,
      questionTypeID,
      questionContent,
    };
  }
  if (matrixAndMatrixListQuestion.includes(questionTypeID)) {
    return {
      ...initialValuesMatrixAndMatrixList,
      questionGroupID,
      departments,
      questionTypeID,
      listMatrixAnsRowIndex: listMatrixRow,
      listMatrixAnsColIndex: listMatrixColumn,
      questionContent,
    };
  }
  if (branchQuestion.includes(questionTypeID)) {
    return {
      ...initialValuesBranch,
      questionGroupID,
      departments,
      questionTypeID,
      questionContent,
    } as unknown as ICreateOneAndManyAnswer;
  }
  if (evaluatedQuestion.includes(questionTypeID)) {
    return initialValueEvaluatedQuestion as unknown as ICreateOneAndManyAnswer;
  }
};

export const FunctionRole = {
  ALL: 'Tất cả',
  EDIT: 'Sửa',
  VIEW: 'Xem',
  SYNC: 'Đồng bộ',
  EXPORT_EXCEL: 'Xuất excel',
  CREATE_SURVEY: 'Tạo bài khảo sát',
  COPY_SURVEY: 'Sao chép bài khảo sát',
  COPY_LINK: 'Sao chép link',
  DELTE: 'DELETE',
  LOCK_SURVEY: 'Khóa bài khảo sát',
  ADD: 'Thêm',
  UPLOAD: 'Upload',
  COPY: 'Sao chép',
};

export enum FunctionGroupName {
  MANAGE_USER_GROUPS = 'Quản lý nhóm người dùng',
  MANAGE_USERS = 'Quản lý người dùng',
  QUESTION_BANK = 'Ngân hàng câu hỏi',
  SURVEYS = 'Bài khảo sát',
}

export enum SideBarTitle {
  SYSTEM_MANAGEMENT = 'Quản trị hệ thống',
  MANAGE_USER_GROUPS = 'Nhóm người dùng',
  MANAGE_USERS = 'Quản lý người dùng',
  QUESTION_BANK = 'Ngân hàng câu hỏi',
  SURVEYS = 'Danh mục bài khảo sát',
  REPORTS = 'Báo cáo',
  HELP = 'Trợ giúp',
  USER_CAMPAIGN = 'Danh sách campain thưởng',
}

export const functionGroupNameArray = [
  {
    5: FunctionGroupName.MANAGE_USER_GROUPS,
  },
  {
    6: FunctionGroupName.MANAGE_USERS,
  },
  {
    7: FunctionGroupName.QUESTION_BANK,
  },
  {
    8: FunctionGroupName.SURVEYS,
  },
];

//function get max item of array
export const getMaxLengthItemOfArray = (data: any, fieldName: string) => {
  if (Array.isArray(data) && data.length > 0) {
    const maxLengthItem = Math.max(
      ...data.map((item: any) => item[fieldName as keyof typeof data].length)
    );
    return maxLengthItem;
  }
  return null;
};

//function convert id -> content string in array

export const convertIdToName = (
  arrayParent: any,
  arrayId: string[] | string,
  fieldID: string,
  filedName: string
) => {
  if (arrayParent && Array.isArray(arrayParent) && arrayParent.length > 0) {
    const itemSelected: string[] = [];
    if (Array.isArray(arrayId) && arrayId.length > 0) {
      arrayId.forEach((item) => {
        const validItem = arrayParent.find(
          (matchItem) => matchItem[fieldID as keyof typeof arrayParent] === item
        );
        if (validItem) {
          itemSelected.push(validItem[filedName as keyof typeof arrayParent]);
        }
      });
      return itemSelected.join(',');
    } else {
      const validItem = arrayParent.find(
        (matchItem) => matchItem[fieldID as keyof typeof arrayParent] === arrayId
      );
      if (validItem) {
        return validItem[filedName as keyof typeof arrayParent];
      }
    }
  }
  return '';
};

export const findQuestionArrByField = (
  groupQuestion: ISectionGroup | null,
  value: string | boolean | number,
  type = 'questionID'
) => {
  if (groupQuestion) {
    const matchQuestion = Object.keys(groupQuestion)
      .map((groupQuestionKey: string) =>
        groupQuestion[groupQuestionKey].question.map((question) => question)
      )
      .flat()
      .filter((ques) => ques[type as keyof typeof ques] === value);
    return matchQuestion;
  }
  return undefined;
};

export const questionType10Obj = [
  {
    questionTypeID: '10',
    questionTypeName: 'Một đáp án - Câu hỏi 360',
    numericalOrder: 0,
  },
];

export const compareLengthArray = (dataChildLength: number, dataParentLength: number) => {
  if (dataChildLength === 0 || dataParentLength === 0) {
    return null;
  }
  const percent = (dataChildLength / dataParentLength) * 100;
  return percent;
};

export const defaultParamsFilter360 = {
  regions: {
    isSelctAll: false,
    regions: null,
  },
  units: {
    isSelctAll: false,
    units: null,
  },
  departments: {
    isSelctAll: false,
    departments: null,
  },
  divisions: {
    isSelctAll: false,
    divisions: null,
  },
  restaurants: {
    isSelctAll: false,
    restaurants: null,
  },
  positions: {
    isSelctAll: false,
    positions: null,
  },
  levels: {
    isSelctAll: false,
    levels: null,
  },
};

export const blankParamsFilter360 = {
  regions: null,
  units: null,
  departments: null,
  divisions: null,
  restaurants: null,
  positions: null,
  levels: null,
};

export const DELAY_TIME_DEBOUNCE_CALL_FUNCTION = 600;

export const reorderItem = (array: any[], startIndex: number, endIndex: number, newValue?: any) => {
  const result = Array.from(array);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, newValue ? newValue : removed);
  return result;
};

export const reorderQuestion = ({
  groupQuestions,
  sourceQuestion,
  destinationQuestion,
  newQuestionInfo,
  typeOrder = 'update',
}: IReorderQuestion) => {
  if (groupQuestions) {
    let currentGroupQuestions = groupQuestions;
    if (typeOrder === 'create' && newQuestionInfo) {
      //case add question ->  add new question at the end of init group question
      currentGroupQuestions = {
        ...currentGroupQuestions,
        [SurveyConst.INIT_GROUP_QUESTION]: {
          ...currentGroupQuestions[SurveyConst.INIT_GROUP_QUESTION],
          question: [
            ...currentGroupQuestions[SurveyConst.INIT_GROUP_QUESTION].question,
            newQuestionInfo,
          ],
        },
      };
    }
    let formatGroupQuestion: ISectionGroup = {};
    switch (sourceQuestion.sectionID) {
      //case reorder question in same section
      case destinationQuestion.sectionID:
        const reorderListQuestion = reorderItem(
          currentGroupQuestions[destinationQuestion.sectionID as keyof typeof currentGroupQuestions]
            .question,
          sourceQuestion.questionIndex,
          destinationQuestion.questionIndex,
          newQuestionInfo
        );
        formatGroupQuestion = {
          ...currentGroupQuestions,
          [destinationQuestion.sectionID]: {
            ...currentGroupQuestions[destinationQuestion.sectionID],
            question: reorderListQuestion,
          },
        };
        break;
      default:
        //case reorder question in different section
        const sourceQuestionClone = [...currentGroupQuestions[sourceQuestion.sectionID].question];
        const destinationQuestionClone = [
          ...currentGroupQuestions[destinationQuestion.sectionID].question,
        ];
        const removedQuestion = sourceQuestionClone.splice(sourceQuestion.questionIndex, 1);
        destinationQuestionClone.splice(
          destinationQuestion.questionIndex,
          0,
          newQuestionInfo ? newQuestionInfo : removedQuestion[0]
        );
        formatGroupQuestion = {
          ...currentGroupQuestions,
          [sourceQuestion.sectionID]: {
            ...currentGroupQuestions[sourceQuestion.sectionID],
            question: sourceQuestionClone,
          },
          [destinationQuestion.sectionID]: {
            ...currentGroupQuestions[destinationQuestion.sectionID],
            question: destinationQuestionClone,
          },
        };
    }
    return formatGroupQuestion;
  }
  return null;
};

//get index and sectionID of question for handle reorder question
export const getQuestionInfoByID = (groupQuestion: ISectionGroup | null, questionID: string) => {
  if (groupQuestion) {
    const questionInfo = {
      questionIndex: 0,
      sectionID: '',
    };
    const arrayGroupQuestions = Object.keys(groupQuestion);
    if (arrayGroupQuestions) {
      arrayGroupQuestions.forEach((groupIndex) => {
        if (Array.isArray(groupQuestion[groupIndex].question)) {
          groupQuestion[groupIndex].question.forEach((question, questionIndex) => {
            if (question.questionID === questionID) {
              questionInfo.questionIndex = questionIndex;
              questionInfo.sectionID = groupIndex;
            }
          });
        }
      });
      return questionInfo;
    }
  }
  return null;
};

export const patternIntegerNumber = /^\d+$/;

export const isIntegerNumber = (input: string) => {
  return patternIntegerNumber.test(input);
};

export const isEmpty = (input: string) => {
  return !input.trim().length;
};
export const formatInputFieldPositiveIntegerNumber = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  /**
   * Allowing: Integers number | Backspace | Tab | Delete | Left & Right arrow keys
   **/
  return (
    !event.key.match(/(^\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/) &&
    event.preventDefault()
  );
};

export const getInfoUserAuth = () => {
  const objInfoPeopleJSON = getLocalStorage('infoUser');
  if (objInfoPeopleJSON) {
    const userInfoData = JSON.parse(objInfoPeopleJSON);
    if (Object.keys(userInfoData).length > 0) return userInfoData;
  }
  return {};
};
export const defaultErrorTextInput = {
  orderQuestion: {
    isCompleted: true,
    message: '',
  },
};

export const deleteMultipleQuestion = (
  groupQuestions: ISectionGroup | null,
  questionIDArray: string[]
) => {
  if (groupQuestions && questionIDArray.length > 0) {
    const formatGroupQuestions = Object.keys(groupQuestions).reduce<ISectionGroup>(
      (groupIndex, curIndex) => {
        const questionArr = groupQuestions[curIndex].question.reduce<CombineTypeAnswer[]>(
          (quesArr, curVal) => {
            if (!questionIDArray.includes(curVal.questionID)) {
              quesArr.push(curVal);
            }
            return quesArr;
          },

          []
        );
        //hidden section when no question
        if (questionArr.length > 0) {
          Object.assign(groupIndex, {
            [curIndex]: {
              ...groupQuestions[curIndex],
              question: questionArr,
            },
          });
        }
        return groupIndex;
      },
      {}
    );
    return formatGroupQuestions;
  }
  return null;
};

export const generateArrayString = (start: number, end: number) => {
  const convertToArrayString = range(start, end).map((x) => `${x}`);
  return convertToArrayString;
};

export const generateTimeString = () => {
  return dayjs().format('DDMMYYYYHHmmssSSS');
};

export const regexImageFile = /(\.jpg|\.jpeg|\.png|\.gif)$/i;

export const fakeAsyncFunction = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export type TResolutionProps = {
  width: number;
  height: number;
};

export type TTypeScreenDevice = 'PC' | 'laptop-13inches' | 'PC-125%' | 'laptop-13inches-125%';
export enum TypeScreenDeviceConstant {
  PC = 'PC',
  LAPTOP13INCHES = 'laptop-13inches',
  PC_125 = 'PC-125%',
  LAPTOP13INCHES_125 = 'laptop-13inches-125%',
}

export const typeResolutionWidth: Record<TTypeScreenDevice, number> = {
  [TypeScreenDeviceConstant.PC]: 1920,
  [TypeScreenDeviceConstant.PC_125]: 1580,
  [TypeScreenDeviceConstant.LAPTOP13INCHES]: 1380,
  [TypeScreenDeviceConstant.LAPTOP13INCHES_125]: 1100,
};
export const typeResolutionHeight: Record<TTypeScreenDevice, number> = {
  [TypeScreenDeviceConstant.PC]: 1080,
  [TypeScreenDeviceConstant.PC_125]: 800,
  [TypeScreenDeviceConstant.LAPTOP13INCHES]: 800,
  [TypeScreenDeviceConstant.LAPTOP13INCHES_125]: 600,
};

export const convertResolutionToSize = (resolution: TResolutionProps) => {
  if (
    resolution.width < typeResolutionWidth[TypeScreenDeviceConstant.LAPTOP13INCHES_125] &&
    resolution.height < typeResolutionHeight[TypeScreenDeviceConstant.LAPTOP13INCHES_125]
  ) {
    return TypeScreenDeviceConstant.LAPTOP13INCHES_125;
  }
  if (
    resolution.width < typeResolutionWidth[TypeScreenDeviceConstant.LAPTOP13INCHES] &&
    resolution.height < typeResolutionHeight[TypeScreenDeviceConstant.LAPTOP13INCHES]
  ) {
    return TypeScreenDeviceConstant.LAPTOP13INCHES;
  }
  if (
    resolution.width < typeResolutionWidth[TypeScreenDeviceConstant.PC_125] &&
    resolution.height < typeResolutionHeight[TypeScreenDeviceConstant.PC_125]
  ) {
    return TypeScreenDeviceConstant.PC_125;
  }
  return TypeScreenDeviceConstant.PC;
};

interface ITableStyles {
  bodyCell: {
    fontSize: number;
  };
  headCell: {
    fontSize: string;
  };
  table: {
    maxHeight: string;
  };
  sizeTableList: 'small' | 'medium';
}

interface IStylePage {
  tableList: ITableStyles;
  boxWrapper: {
    padding: string;
  };
}

interface IStyleReportPage extends IStylePage {
  formSearch: {
    margin: string;
  };
}

interface IStyleCSSForSmallScreenProps {
  survey: IStylePage;
  report: IStyleReportPage;
  userGroup: IStylePage;
  userManagement: IStylePage;
  questionBank: IStylePage;
}

export const styleCSSForSmallScreen: Record<TTypeScreenDevice, IStyleCSSForSmallScreenProps> = {
  [TypeScreenDeviceConstant.PC]: {
    survey: {
      tableList: {
        bodyCell: {
          fontSize: 16,
        },
        headCell: {
          fontSize: '18px',
        },
        table: {
          maxHeight: '400px',
        },
        sizeTableList: 'medium',
      },
      boxWrapper: {
        padding: '16px',
      },
    },

    report: {
      tableList: {
        bodyCell: {
          fontSize: 16,
        },
        headCell: {
          fontSize: '18px',
        },
        table: {
          maxHeight: '480px',
        },
        sizeTableList: 'medium',
      },
      boxWrapper: {
        padding: '16px',
      },
      formSearch: {
        margin: '16px 0',
      },
    },

    userGroup: {
      tableList: {
        bodyCell: {
          fontSize: 16,
        },
        headCell: {
          fontSize: '18px',
        },
        table: {
          maxHeight: '490px',
        },
        sizeTableList: 'medium',
      },
      boxWrapper: {
        padding: '16px',
      },
    },

    userManagement: {
      tableList: {
        bodyCell: {
          fontSize: 16,
        },
        headCell: {
          fontSize: '18px',
        },
        table: {
          maxHeight: '450px',
        },
        sizeTableList: 'medium',
      },
      boxWrapper: {
        padding: '16px',
      },
    },

    questionBank: {
      tableList: {
        bodyCell: {
          fontSize: 16,
        },
        headCell: {
          fontSize: '18px',
        },
        table: {
          maxHeight: '490px',
        },
        sizeTableList: 'medium',
      },
      boxWrapper: {
        padding: '16px',
      },
    },
  },
  [TypeScreenDeviceConstant.PC_125]: {
    survey: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '235px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '16px',
      },
    },

    report: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '380px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '16px',
      },
      formSearch: {
        margin: '16px 0',
      },
    },

    userGroup: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '348px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '16px',
      },
    },

    userManagement: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '348px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '16px',
      },
    },

    questionBank: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '336px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '16px',
      },
    },
  },
  [TypeScreenDeviceConstant.LAPTOP13INCHES]: {
    survey: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '218px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '16px',
      },
    },

    report: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '290px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '16px',
      },
      formSearch: {
        margin: '16px 0',
      },
    },

    userGroup: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '290px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '16px',
      },
    },

    userManagement: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '290px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '16px',
      },
    },

    questionBank: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '306px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '16px',
      },
    },
  },
  [TypeScreenDeviceConstant.LAPTOP13INCHES_125]: {
    survey: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '110px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '0px',
      },
    },

    report: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '205px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '12px',
      },
      formSearch: {
        margin: '12px 0 0 0',
      },
    },

    userGroup: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '168px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '0',
      },
    },

    userManagement: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '168px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '0',
      },
    },

    questionBank: {
      tableList: {
        bodyCell: {
          fontSize: 14,
        },
        headCell: {
          fontSize: '16px',
        },
        table: {
          maxHeight: '170px',
        },
        sizeTableList: 'small',
      },
      boxWrapper: {
        padding: '12px',
      },
    },
  },
};

export type EventSourceListener = {
  onData: (data: any) => void;
  onError: (error: Event) => void;
};

export const openSSEConnection = (url: string) => {
  const domainUrl = `${process.env.REACT_APP_API_HOST}/api`;
  const eventListeners: EventSourceListener[] = [];
  let eventSource: EventSource | null = null;

  const openConnection = () => {
    eventSource = new EventSource(domainUrl + url);

    eventSource.onmessage = (event) => {
      eventListeners.forEach((listener) => {
        listener.onData(event.data);
      });
    };

    eventSource.onerror = (error) => {
      eventListeners.forEach((listener) => {
        listener.onError(error);
      });
    };
  };

  const closeConnection = () => {
    if (eventSource) {
      eventSource.close();
      eventSource = null;
    }
  };

  const addListener = (listener: EventSourceListener) => {
    eventListeners.push(listener);
  };

  const removeListener = (listener: EventSourceListener) => {
    const index = eventListeners.indexOf(listener);
    if (index !== -1) {
      eventListeners.splice(index, 1);
    }
  };

  return {
    openConnection,
    closeConnection,
    addListener,
    removeListener,
  };
};

export const handleScrollToNextQuestion = (nextQuestionElement: any) => {
  if (
    !nextQuestionElement ||
    !nextQuestionElement?.offsetHeight ||
    !nextQuestionElement?.getBoundingClientRect ||
    !window.scrollTo
  ) {
    return 0;
  }

  const viewportHeight = window.innerHeight;
  const elementHeight = nextQuestionElement.offsetHeight;
  const fixedHeaderHeight = 100; // height of fixed header

  let scrollTop = window.scrollY;

  if (elementHeight <= viewportHeight) {
    // If the element height is smaller or equal to the viewport height, center it in the viewport
    const elementTop = nextQuestionElement.getBoundingClientRect().top;
    scrollTop += elementTop - (viewportHeight - elementHeight) / 2;
  } else {
    // If the element height is greater than the viewport height, scroll to the top
    const nextElementTop = nextQuestionElement.getBoundingClientRect().top;
    scrollTop += nextElementTop - fixedHeaderHeight;
  }

  if (document.body.scrollHeight <= window.innerHeight) {
    setLocalStorage(IS_PRIORITY_CLICK_HIGHLIGHT, 'false');
    // Page content fits within the viewport, no need to scroll
    return -1;
  }

  /*
   * In case it is not possible to scroll to the next question, it will return -1 to highlight next question
   * When IS_PRIORITY_CLICK_HIGHLIGHT = true, logic will not run to highlight the question closest to the center of the screen when scrolling
   */

  if (scrollTop < 0) {
    if (window.scrollY === 0) {
      //Can't scroll -> highlight next question
      setLocalStorage(IS_PRIORITY_CLICK_HIGHLIGHT, 'false');
      return -1;
    } else {
      //Scroll to first question
      setLocalStorage(IS_PRIORITY_CLICK_HIGHLIGHT, 'true');
    }
  }

  if (Math.round(window.scrollY) === Math.round(scrollTop)) {
    //Case already at Desired Position -> highlight next question
    setLocalStorage(IS_PRIORITY_CLICK_HIGHLIGHT, 'false');
    return -1;
  }

  window.scrollTo({
    top: Math.round(scrollTop),
    behavior: 'smooth',
  });

  if (scrollTop >= document.documentElement.scrollHeight - window.innerHeight) {
    //Case scroll to a position larger than the scrollable vertical scrollbar
    setLocalStorage(IS_PRIORITY_CLICK_HIGHLIGHT, 'true');
    return -1;
  }

  return scrollTop;
};

const sortArrayAlphabetically = (arr: any[], fieldID: string) => {
  return arr.sort((a, b) => {
    const valueA = a[fieldID].toUpperCase(); // Convert to uppercase for case-insensitive sorting
    const valueB = b[fieldID].toUpperCase();

    if (valueA < valueB) {
      return -1; // a should come before b
    }
    if (valueA > valueB) {
      return 1; // a should come after b
    }
    return 0; // a and b are equal
  });
};

/**
 * Sorts a list of items based on their presence in a selected array.
 * Items present in the selected array come first in the sorted result.
 * @param {Array} listArray - The list of items to be sorted.
 * @param {Array} selectedArray - The array of selected items.
 * @param {string} fieldID - The field used for comparison.
 * @returns {Array} - The sorted list.
 */
export const sortListBySelection = (
  listArray: any[],
  selectedArray: any[],
  fieldID: string,
  fieldForSort: string,
  isSearching = false
): any[] => {
  const keyInListArray = Object.keys(listArray[0] || []);
  const keyInSelectedArray = Object.keys(selectedArray[0] || []);

  // Check if both listArray and selectedArray are arrays
  if (
    !Array.isArray(listArray) ||
    !Array.isArray(selectedArray) ||
    !keyInListArray.includes(fieldID) ||
    !keyInListArray.includes(fieldForSort) ||
    !keyInSelectedArray.includes(fieldID) ||
    !keyInSelectedArray.includes(fieldForSort)
  ) {
    return listArray; // Return the original list if input is invalid
  }

  const isHasAllOption = listArray.find((item) => item[fieldID] === 'all');

  let listSorted = [];

  const uniqueIDArray = new Set(selectedArray.map((item) => item[fieldID]));
  const listObj = listArray.reduce<any>(
    (acc, cur) => {
      if (!uniqueIDArray.has(cur[fieldID]) && cur[fieldID] !== 'all') {
        acc.notInclude.push(cur);
      } else if (uniqueIDArray.has(cur[fieldID])) {
        acc.include.push(cur);
      }
      return acc;
    },
    {
      include: [],
      notInclude: [],
    }
  );

  if (isSearching) {
    listSorted = [...sortArrayAlphabetically(listObj.include, fieldForSort), ...listObj.notInclude];
  } else {
    listSorted = [...sortArrayAlphabetically(selectedArray, fieldForSort), ...listObj.notInclude];
  }
  if (isHasAllOption) {
    listSorted.unshift(isHasAllOption);
  }

  return uniqBy(listSorted, fieldID);
};

export const handleTransformSurveyViewerData = (
  listViewer: ISurveyUserReview[],
  selectedID: string[]
) => {
  const listKey = Object.keys(listViewer[0] || []);
  if (
    !Array.isArray(listViewer) ||
    !Array.isArray(selectedID) ||
    !listKey ||
    !listKey.includes('viewerID')
  ) {
    return [];
  }
  return listViewer.reduce<ISurveyUserReview[]>((acc, cur) => {
    if (selectedID.includes(cur.viewerID)) {
      acc.push(cur);
    }
    return acc;
  }, []);
};

export const DELAY_TIME_TO_NAVIGATE = 1500;
export const API_NOT_CHECK_UNAUTHORIZED = ['/SurveyResults/checkSurveyResults'];

export const isMatchPathUnauthorized = (url: string) => {
  if (!url || typeof url !== 'string') {
    return false;
  }
  const isMatch = API_NOT_CHECK_UNAUTHORIZED.find((path) => url.includes(path));
  return Boolean(isMatch);
};

// handle get selected icon color for question rating type 1,2,5,6,7

export const handleGetSelectedRatingIconMultipleColor = (
  currentIcon: string | number,
  currentIconSelected: string | number,
  currentIonHover: string | number,
  disabled: boolean
) => {
  const selectedColor = RATING_SELECTED_COLOR[String(currentIcon)]
    ? RATING_SELECTED_COLOR[String(currentIcon)]
    : colors.warningMain;
  if (String(currentIcon) === String(currentIconSelected)) {
    if (disabled) {
      return colors.textDisabled;
    }
    return selectedColor;
  }
  if (String(currentIcon) === String(currentIonHover)) {
    return selectedColor;
  }
  return RATING_DEFAULT_COLOR;
};

export const handleLoadMoreStaff = async ({
  page,
  pageSize,
  searchText,
  controller,
}: FetchFunctionProps): Promise<ItemsType[]> => {
  const response = await postDDLSearchStaffApi({
    page,
    pageSize,
    keyWord: searchText,
    surveyId: '',
    controller,
  });

  const formattedResponse =
    Array.isArray(response) && response?.length > 0
      ? response?.map?.((item) => ({
          value: item.value,
          label: `${item.text} - ${item.detailedValue}`,
        }))
      : [];
  return formattedResponse;
};
